document.addEventListener('DOMContentLoaded', () => {
  initHiranyaHome();
  initHiranyaSeo();
  initHiranyaHeader();
  initHiranyaProductForms();
  initHiranyaWelcomePopup();
});

function hiranyaEscapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function hiranyaFormatMoney(amount, currency = '₹') {
  const parsedAmount = Number(amount) || 0;
  const hasDecimals = Math.abs(parsedAmount - Math.round(parsedAmount)) > 0.001;
  const currencyLabel = !currency || currency === 'INR' ? '₹' : currency;

  return `${currencyLabel} ${parsedAmount.toLocaleString('en-IN', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  })}`;
}

function hiranyaNormalizeSkuKey(value) {
  return String(value ?? '').trim().toUpperCase();
}

function hiranyaLoadSkuMap(url) {
  if (!url) {
    return Promise.resolve({});
  }

  if (window.__hiranyaSkuMapPromise && window.__hiranyaSkuMapUrl === url) {
    return window.__hiranyaSkuMapPromise;
  }

  window.__hiranyaSkuMapUrl = url;
  window.__hiranyaSkuMapPromise = fetch(url, {
    headers: { Accept: 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Unable to load SKU map.');
    }

    return response.json();
  });

  return window.__hiranyaSkuMapPromise;
}

function hiranyaBuildPairCardMarkup(pairItem) {
  if (!pairItem || !Array.isArray(pairItem.variants) || !pairItem.variants.length) {
    return '';
  }

  const productUrl = pairItem.url || `/products/${pairItem.handle}`;
  const featuredImage = pairItem.featuredImage || '';
  const currentVariant =
    pairItem.variants.find((variant) => String(variant.id) === String(pairItem.selectedVariantId)) ||
    pairItem.variants[0];
  const currentPrice = currentVariant
    ? hiranyaFormatMoney((Number(currentVariant.priceCents) || 0) / 100, '₹')
    : '';
  const currentAvailable = Boolean(currentVariant?.available);
  const pairImage = hiranyaImageUrlWithWidth(featuredImage, 360);
  const imageMarkup = featuredImage
    ? `<img src="${hiranyaEscapeHtml(pairImage)}" alt="${hiranyaEscapeHtml(pairItem.title)}" loading="lazy" decoding="async">`
    : '';
  const optionsMarkup = pairItem.variants
    .map((variant) => {
      const label =
        variant.title && variant.title !== 'Default Title' ? String(variant.title).toUpperCase() : 'STD';
      const optionText = variant.available ? label : `${label} - SOLD OUT`;
      const selected = String(variant.id) === String(currentVariant?.id) ? ' selected' : '';
      const disabled = variant.available ? '' : ' disabled';

      return `<option value="${hiranyaEscapeHtml(variant.id)}" data-price="${hiranyaEscapeHtml(
        hiranyaFormatMoney((Number(variant.priceCents) || 0) / 100, '₹')
      )}" data-available="${variant.available ? 'true' : 'false'}"${selected}${disabled}>${hiranyaEscapeHtml(
        optionText
      )}</option>`;
    })
    .join('');

  return `
    <div class="hiranya-pdp__pair-card">
      <a class="hiranya-pdp__pair-media" href="${hiranyaEscapeHtml(productUrl)}">
        ${imageMarkup}
      </a>
      <div class="hiranya-pdp__pair-copy">
        <a class="hiranya-pdp__pair-name" href="${hiranyaEscapeHtml(productUrl)}">${hiranyaEscapeHtml(pairItem.title)}</a>
        <p class="hiranya-pdp__pair-price" data-hiranya-pair-price>${hiranyaEscapeHtml(currentPrice)}</p>
        <form method="post" action="${hiranyaEscapeHtml(window.theme?.routes?.cart_add_url || '/cart/add')}" class="hiranya-pdp__pair-form" data-hiranya-pair-form>
          <div class="hiranya-pdp__pair-select-wrap">
            <select name="id" class="hiranya-pdp__pair-select" data-hiranya-pair-select>
              ${optionsMarkup}
            </select>
          </div>
          <button type="submit" class="hiranya-pdp__pair-button"${currentAvailable ? '' : ' disabled'}>${currentAvailable ? 'Add' : 'Sold Out'}</button>
        </form>
      </div>
    </div>
  `;
}

function hiranyaResolveProductFabric(product, fabricMap = {}) {
  const handle = product?.handle || '';
  const candidates = [
    product?.fabric,
    product?.fabric_list,
    product?.metafields?.custom?.fabric_list,
    handle ? fabricMap[handle] : '',
  ];

  return String(candidates.find((value) => String(value || '').trim()) || '').trim();
}

function hiranyaImageUrlWithWidth(imageUrl, width = 700) {
  const rawUrl = String(imageUrl || '').trim();

  if (!rawUrl) {
    return '';
  }

  try {
    const normalizedUrl = rawUrl.startsWith('//')
      ? `${window.location.protocol}${rawUrl}`
      : rawUrl;
    const url = new URL(normalizedUrl, window.location.origin);
    const isShopifyCdn =
      url.hostname.includes('cdn.shopify.com') ||
      url.pathname.includes('/cdn/shop/') ||
      url.pathname.includes('/s/files/');

    if (isShopifyCdn) {
      url.searchParams.set('width', String(width));
    }

    return url.toString();
  } catch (error) {
    return rawUrl;
  }
}

function hiranyaLoadDeferredImage(image) {
  if (!(image instanceof HTMLImageElement) || image.dataset.hiranyaImageLoaded === 'true') {
    return;
  }

  const src = image.dataset.hiranyaDeferredSrc || image.dataset.hiranyaHoverSrc;
  const srcset = image.dataset.hiranyaDeferredSrcset || image.dataset.hiranyaHoverSrcset;
  const sizes = image.dataset.hiranyaDeferredSizes || image.dataset.hiranyaHoverSizes;

  if (sizes) {
    image.setAttribute('sizes', sizes);
  }

  if (srcset) {
    image.setAttribute('srcset', srcset);
  }

  if (src) {
    image.setAttribute('src', src);
  }

  image.dataset.hiranyaImageLoaded = 'true';
}

function hiranyaHydrateDeferredImages(root = document) {
  root.querySelectorAll('[data-hiranya-deferred-src]').forEach((image) => {
    hiranyaLoadDeferredImage(image);
  });
}

function hiranyaHydrateHoverImages(root = document) {
  root.querySelectorAll('[data-hiranya-hover-src]').forEach((image) => {
    hiranyaLoadDeferredImage(image);
  });
}

function hiranyaBindHoverImageLoading(root = document) {
  root.querySelectorAll('[data-hiranya-hover-image-root]').forEach((hoverRoot) => {
    if (hoverRoot.dataset.hiranyaHoverBound === 'true') {
      return;
    }

    const loadImages = () => {
      hiranyaHydrateHoverImages(hoverRoot);
    };

    hoverRoot.addEventListener('pointerenter', loadImages, { once: true });
    hoverRoot.addEventListener('focusin', loadImages, { once: true });
    hoverRoot.addEventListener('touchstart', loadImages, { once: true, passive: true });
    hoverRoot.dataset.hiranyaHoverBound = 'true';
  });
}

function hiranyaLoadReelsVideo(video) {
  if (!(video instanceof HTMLVideoElement) || video.dataset.hiranyaVideoLoaded === 'true') {
    return;
  }

  const sourceUrl = video.dataset.hiranyaVideoSrc;

  if (!sourceUrl) {
    return;
  }

  const source = document.createElement('source');
  source.src = sourceUrl;
  source.type = 'video/mp4';
  video.appendChild(source);
  video.load();
  video.dataset.hiranyaVideoLoaded = 'true';
}

function hiranyaBuildProductCardMarkup(product, fabricMap = {}) {
  const productUrl = product.url || `/products/${product.handle}`;
  const imageUrl =
    (typeof product.featured_image === 'string' && product.featured_image) ||
    product.featured_image?.src ||
    product.image?.src ||
    product.image ||
    product.images?.[0] ||
    '';
  const sizedImageUrl = hiranyaImageUrlWithWidth(imageUrl, 700);
  const imageMarkup = imageUrl
    ? `
      <div class="hiranya-collection-card__media">
        <img class="hiranya-collection-card__image" src="${hiranyaEscapeHtml(sizedImageUrl)}" alt="${hiranyaEscapeHtml(product.title)}" loading="lazy" decoding="async" sizes="(min-width: 1024px) 25vw, 70vw">
      </div>
    `
    : '<div class="hiranya-collection-card__media"></div>';
  const fabric = hiranyaResolveProductFabric(product, fabricMap);
  const fabricMarkup = fabric
    ? `<p class="hiranya-collection-card__fabric">${hiranyaEscapeHtml(fabric)}</p>`
    : '';

  return `
    <a class="hiranya-collection-card hiranya-collection-card--small" href="${hiranyaEscapeHtml(productUrl)}">
      ${imageMarkup}
      <div class="hiranya-collection-card__caption">
        <h3 class="hiranya-collection-card__title hiranya-collection-card__title--small">${hiranyaEscapeHtml(product.title)}</h3>
        ${fabricMarkup}
        <p class="hiranya-collection-card__price">${hiranyaEscapeHtml(hiranyaFormatMoney((Number(product.price) || 0) / 100, '₹'))}</p>
      </div>
    </a>
  `;
}

function initHiranyaHome() {
  const arrivalsRoot = document.querySelector('[data-hiranya-arrivals]');
  const reelsVideos = Array.from(document.querySelectorAll('[data-hiranya-reels-video]'));

  hiranyaBindHoverImageLoading(document);

  if (reelsVideos.length) {
    reelsVideos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    });

    if ('IntersectionObserver' in window) {
      const reelsObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;

            if (!(video instanceof HTMLVideoElement)) {
              return;
            }

            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              hiranyaLoadReelsVideo(video);
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          });
        },
        {
          rootMargin: '200px 0px',
          threshold: [0, 0.35, 0.75],
        }
      );

      reelsVideos.forEach((video) => {
        reelsObserver.observe(video);
      });
    } else {
      reelsVideos.forEach((video) => {
        hiranyaLoadReelsVideo(video);
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    }
  }

  if (arrivalsRoot) {
    const tabs = Array.from(arrivalsRoot.querySelectorAll('[data-arrivals-tab]'));
    const panels = Array.from(arrivalsRoot.querySelectorAll('[data-arrivals-panel]'));
    const viewAllLink = arrivalsRoot.querySelector('[data-arrivals-view-all]');

    if (!tabs.length || !panels.length) {
      return;
    }

    const setActiveTab = (target, url) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.arrivalsTab === target || tab.dataset.target === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActivePanel = panel.dataset.arrivalsPanel === target;

        if (isActivePanel) {
          hiranyaHydrateDeferredImages(panel);
          hiranyaBindHoverImageLoading(panel);
        }

        panel.hidden = !isActivePanel;
      });

      if (viewAllLink && url) {
        viewAllLink.setAttribute('href', url);
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        setActiveTab(tab.dataset.target, tab.dataset.url);
      });
    });

    const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    if (initialTab) {
      setActiveTab(initialTab.dataset.target, initialTab.dataset.url);
    }
  }
}

function initHiranyaSeo() {
  const homeToggle = document.querySelector('[data-hiranya-home-seo-toggle]');
  const homeMore = document.querySelector('[data-hiranya-home-seo-more]');

  if (homeToggle && homeMore) {
    homeToggle.addEventListener('click', () => {
      const isExpanded = !homeMore.hidden;
      homeMore.hidden = isExpanded;
      homeToggle.textContent = isExpanded ? 'Read More' : 'Read Less';
      homeToggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
  }

  document.querySelectorAll('[data-hiranya-collection-seo-content]').forEach((content) => {
    const seoRoot = content.querySelector('.productlist-desc');

    if (seoRoot) {
      seoRoot.querySelectorAll('style').forEach((styleNode) => {
        styleNode.remove();
      });

      let isFaqSection = false;

      Array.from(seoRoot.children).forEach((node) => {
        const tagName = node.tagName?.toLowerCase();
        const headingText = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

        if (tagName && /^h[2-5]$/.test(tagName)) {
          isFaqSection = headingText.includes('faq');
        }

        if (!isFaqSection) {
          return;
        }

        if (tagName && /^h[2-5]$/.test(tagName) && !headingText.includes('faq')) {
          node.classList.add('hiranya-faq-question');
          node.querySelectorAll('strong, b').forEach((strongNode) => {
            strongNode.classList.add('hiranya-faq-plain');
          });
        }
      });
    }

    const toggle = content.parentElement?.querySelector('[data-hiranya-collection-seo-toggle]');
    if (!toggle) {
      return;
    }

    const directChildren = Array.from(content.children);
    const paragraphs = directChildren.filter((element) => element.tagName === 'P');

    if (paragraphs.length < 3) {
      return;
    }

    const secondParagraph = paragraphs[1];
    const trailingNodes = [];
    let nextNode = secondParagraph.nextSibling;

    while (nextNode) {
      const currentNode = nextNode;
      nextNode = nextNode.nextSibling;

      if (currentNode.nodeType === 1 || (currentNode.nodeType === 3 && currentNode.textContent.trim())) {
        trailingNodes.push(currentNode);
      }
    }

    if (!trailingNodes.length) {
      return;
    }

    const hiddenContent = document.createElement('div');
    hiddenContent.className = 'hiranya-collection-seo__more';
    hiddenContent.hidden = true;

    trailingNodes.forEach((node) => {
      hiddenContent.appendChild(node);
    });

    content.appendChild(hiddenContent);
    toggle.hidden = false;

    toggle.addEventListener('click', () => {
      const isExpanded = !hiddenContent.hidden;
      hiddenContent.hidden = isExpanded;
      toggle.textContent = isExpanded ? 'Read More' : 'Read Less';
      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
  });
}

function initHiranyaHeader() {
  const header = document.querySelector('[data-hiranya-header]');
  const backdrop = document.querySelector('[data-hiranya-header-backdrop]');
  const miniCart = document.querySelector('[data-hiranya-mini-cart]');
  const mobileNav = document.querySelector('[data-hiranya-mobile-nav]');
  const mobileNavToggles = Array.from(document.querySelectorAll('[data-hiranya-mobile-nav-toggle]'));
  const mobileSearchToggle = document.querySelector('[data-hiranya-mobile-footer-search]');
  const mobileCartToggle = document.querySelector('[data-hiranya-mobile-footer-cart]');

  if (!header || !backdrop || !miniCart) {
    return;
  }

  const searchPanel = header.querySelector('[data-hiranya-search-panel]');
  const searchToggle = header.querySelector('[data-hiranya-search-toggle]');
  const searchClose = header.querySelector('[data-hiranya-search-close]');
  const searchForm = header.querySelector('[data-hiranya-search-form]');
  const searchInput = header.querySelector('[data-hiranya-search-input]');
  const searchResults = header.querySelector('[data-hiranya-search-results]');
  const cartToggle = header.querySelector('[data-hiranya-cart-toggle]');
  const cartClose = miniCart.querySelector('[data-hiranya-cart-close]');
  const cartContent = miniCart.querySelector('[data-hiranya-mini-cart-content]');
  const cartFooter = miniCart.querySelector('[data-hiranya-mini-cart-footer]');
  const cartCountNodes = Array.from(document.querySelectorAll('[data-hiranya-cart-count]'));

  let activePanel = null;
  let searchTimer = null;
  let searchRequestId = 0;
  const syncMobileNavToggles = (isOpen) => {
    mobileNavToggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.classList.toggle('is-active', isOpen);
    });
  };

  const closePanels = () => {
    activePanel = null;
    header.classList.remove('is-search-open', 'is-cart-open');
    searchPanel.classList.remove('is-querying');
    miniCart.classList.remove('is-open');
    mobileNav?.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    miniCart.setAttribute('aria-hidden', 'true');
    mobileNav?.setAttribute('aria-hidden', 'true');
    searchToggle?.setAttribute('aria-expanded', 'false');
    cartToggle?.setAttribute('aria-expanded', 'false');
    syncMobileNavToggles(false);
    document.body.classList.remove('hiranya-ui-open', 'hiranya-mobile-nav-open');
  };

  const openSearch = () => {
    const shouldClose = activePanel === 'search';
    closePanels();

    if (shouldClose) {
      return;
    }

    activePanel = 'search';
    header.classList.add('is-search-open');
    header.classList.remove('is-cart-open');
    miniCart.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'false');
    miniCart.setAttribute('aria-hidden', 'true');
    searchToggle?.setAttribute('aria-expanded', 'true');
    cartToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.add('hiranya-ui-open');
    window.setTimeout(() => searchInput?.focus(), 30);
  };

  const showCart = async () => {
    activePanel = 'cart';
    header.classList.add('is-cart-open');
    header.classList.remove('is-search-open');
    searchPanel.classList.remove('is-querying');
    miniCart.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    miniCart.setAttribute('aria-hidden', 'false');
    searchToggle?.setAttribute('aria-expanded', 'false');
    cartToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('hiranya-ui-open');
    await loadCart();
  };

  const openCart = async () => {
    const shouldClose = activePanel === 'cart';
    closePanels();

    if (shouldClose) {
      return;
    }

    await showCart();
  };

  const openMobileNav = () => {
    if (!mobileNav || !mobileNavToggles.length) {
      return;
    }

    const shouldClose = activePanel === 'mobile-nav';
    closePanels();

    if (shouldClose) {
      return;
    }

    activePanel = 'mobile-nav';
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    syncMobileNavToggles(true);
    document.body.classList.add('hiranya-mobile-nav-open');
  };

  const formatMoney = (amount, currency) => {
    const parsedAmount = Number(amount) || 0;
    const hasDecimals = Math.abs(parsedAmount - Math.round(parsedAmount)) > 0.001;
    const currencyLabel = !currency || currency === 'INR' ? '₹' : currency;

    return `${currencyLabel} ${parsedAmount.toLocaleString('en-IN', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    })}`;
  };

  const escapeHtml = (value) => {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const updateCartCount = (count) => {
    cartCountNodes.forEach((node) => {
      node.textContent = String(count);
      node.classList.toggle('is-hidden', count < 1);
    });
  };

  const renderCart = (cart) => {
    updateCartCount(cart.item_count || 0);

    if (!cart.items || cart.items.length === 0) {
      cartContent.innerHTML = `
        <div>
          <p class="hiranya-mini-cart__empty">Your cart is empty.</p>
          <a class="hiranya-mini-cart__empty-cta" href="/collections/all-products">Continue Shopping</a>
        </div>
      `;
      cartFooter.innerHTML = '';
      return;
    }

    cartContent.innerHTML = `
      <div class="hiranya-mini-cart__items">
        ${cart.items
          .map((item, index) => {
            const variant = item.variant_title && item.variant_title !== 'Default Title'
              ? `<span class="hiranya-mini-cart__variant">${escapeHtml(item.variant_title)}</span>`
              : '';
            const cartImage = hiranyaImageUrlWithWidth(item.image, 240);
            const media = item.image
              ? `<img src="${escapeHtml(cartImage)}" alt="${escapeHtml(item.product_title)}" loading="lazy" decoding="async">`
              : '';

            return `
              <article class="hiranya-mini-cart__item">
                <a class="hiranya-mini-cart__item-media" href="${item.url}">
                  ${media}
                </a>
                <div class="hiranya-mini-cart__item-copy">
                  <a class="hiranya-mini-cart__item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
                  ${variant}
                  <div class="hiranya-mini-cart__meta">Qty ${item.quantity} · ${formatMoney(item.final_line_price / 100, cart.currency)}</div>
                  <button class="hiranya-mini-cart__remove" type="button" data-hiranya-cart-remove data-line="${index + 1}">Remove</button>
                </div>
              </article>
            `;
          })
          .join('')}
      </div>
    `;

    cartFooter.innerHTML = `
      <div class="hiranya-mini-cart__summary">
        <span class="hiranya-mini-cart__summary-label">Subtotal</span>
        <span class="hiranya-mini-cart__summary-value">${formatMoney(cart.total_price / 100, cart.currency)}</span>
      </div>
      <div class="hiranya-mini-cart__buttons">
        <a class="hiranya-mini-cart__button hiranya-mini-cart__button--primary" href="/checkout">Checkout</a>
        <a class="hiranya-mini-cart__button hiranya-mini-cart__button--secondary" href="${window.theme?.routes?.cart_url || '/cart'}">View Cart</a>
      </div>
    `;
  };

  const loadCart = async () => {
    cartContent.innerHTML = '<p class="hiranya-mini-cart__status">Loading cart…</p>';
    cartFooter.innerHTML = '';

    try {
      const response = await fetch(`${window.theme?.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      cartContent.innerHTML = '<p class="hiranya-mini-cart__status">Unable to load the cart right now.</p>';
      cartFooter.innerHTML = '';
    }
  };

  const updateCartLine = async (line, quantity) => {
    cartContent.innerHTML = '<p class="hiranya-mini-cart__status">Updating cart…</p>';
    cartFooter.innerHTML = '';

    try {
      const response = await fetch(`${window.theme?.routes?.cart_change_url || '/cart/change'}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line, quantity }),
      });

      if (!response.ok) {
        throw new Error('Unable to update cart');
      }

      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      cartContent.innerHTML = '<p class="hiranya-mini-cart__status">Unable to update the cart right now.</p>';
      cartFooter.innerHTML = '';
    }
  };

  const renderSearchResults = (resources, query) => {
    const groups = [];

    const buildCard = (item, typeLabel, price) => {
      const imageUrl = item.featured_image?.url || item.image || '';
      const searchImageUrl = hiranyaImageUrlWithWidth(imageUrl, 240);
      const imageMarkup = imageUrl
        ? `
          <span class="hiranya-search-result-card__media">
            <img src="${escapeHtml(searchImageUrl)}" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async">
          </span>
        `
        : '<span class="hiranya-search-result-card__media"></span>';

      const priceMarkup = price ? `<div class="hiranya-search-result-card__price">${price}</div>` : '';

      return `
        <a class="hiranya-search-result-card" href="${item.url}">
          ${imageMarkup}
          <span>
            <div class="hiranya-search-result-card__type">${typeLabel}</div>
            <div class="hiranya-search-result-card__name">${escapeHtml(item.title)}</div>
            ${priceMarkup}
          </span>
        </a>
      `;
    };

    if (resources.products?.length) {
      groups.push(`
        <section class="hiranya-search-results__group">
          <h3 class="hiranya-search-results__title">Products</h3>
          <div class="hiranya-search-results__items">
            ${resources.products
              .map((product) => buildCard(product, 'Product', formatMoney(product.price, '₹')))
              .join('')}
          </div>
        </section>
      `);
    }

    if (resources.collections?.length) {
      groups.push(`
        <section class="hiranya-search-results__group">
          <h3 class="hiranya-search-results__title">Collections</h3>
          <div class="hiranya-search-results__items">
            ${resources.collections.map((collection) => buildCard(collection, 'Collection', '')).join('')}
          </div>
        </section>
      `);
    }

    if (resources.pages?.length) {
      groups.push(`
        <section class="hiranya-search-results__group">
          <h3 class="hiranya-search-results__title">Pages</h3>
          <div class="hiranya-search-results__items">
            ${resources.pages.map((page) => buildCard(page, 'Page', '')).join('')}
          </div>
        </section>
      `);
    }

    if (!groups.length) {
      searchResults.innerHTML = `<p class="hiranya-search-results__empty">No results found for "${escapeHtml(query)}".</p>`;
      return;
    }

    searchResults.innerHTML = `
      ${groups.join('')}
      <div class="hiranya-search-results__footer">
        <a class="hiranya-search-results__view-all" href="${window.theme?.routes?.search_url || '/search'}?q=${encodeURIComponent(query)}">View all results</a>
      </div>
    `;
  };

  const runPredictiveSearch = async (query) => {
    const requestId = ++searchRequestId;
    searchPanel.classList.add('is-querying');
    searchResults.innerHTML = '<p class="hiranya-search-results__status">Searching…</p>';

    try {
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,page',
        'resources[limit]': '4',
        'resources[options][unavailable_products]': 'hide',
        'resources[options][fields]': 'title,product_type,variants.title,vendor',
      });
      const response = await fetch(`${window.theme?.routes?.predictive_search_url || '/search/suggest'}.json?${params.toString()}`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Unable to load search suggestions');
      }

      const data = await response.json();

      if (requestId !== searchRequestId) {
        return;
      }

      renderSearchResults(data.resources?.results || {}, query);
    } catch (error) {
      if (requestId !== searchRequestId) {
        return;
      }

      searchResults.innerHTML = '<p class="hiranya-search-results__status">Unable to load suggestions right now.</p>';
    }
  };

  window.HiranyaUI = Object.assign(window.HiranyaUI || {}, {
    openCart: showCart,
    openSearch,
    openMobileNav,
    closePanels,
    refreshCart: loadCart,
  });

  searchToggle?.addEventListener('click', (event) => {
    event.preventDefault();
    openSearch();
  });

  searchClose?.addEventListener('click', () => {
    closePanels();
  });

  cartToggle?.addEventListener('click', async (event) => {
    event.preventDefault();
    await openCart();
  });

  mobileNavToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      openMobileNav();
    });
  });

  mobileSearchToggle?.addEventListener('click', (event) => {
    event.preventDefault();
    openSearch();
  });

  mobileCartToggle?.addEventListener('click', async (event) => {
    event.preventDefault();
    await openCart();
  });

  cartClose?.addEventListener('click', () => {
    closePanels();
  });

  backdrop.addEventListener('click', () => {
    closePanels();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closePanels();
    }
  });

  mobileNav?.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      closePanels();
    }
  });

  searchForm?.addEventListener('submit', () => {
    closePanels();
  });

  searchInput?.addEventListener('input', () => {
    const query = searchInput.value.trim();
    window.clearTimeout(searchTimer);

    if (query.length < 2) {
      searchRequestId += 1;
      searchPanel.classList.remove('is-querying');
      searchResults.innerHTML = '<p class="hiranya-search-results__empty">Start typing to see products, collections, and pages.</p>';
      return;
    }

    searchTimer = window.setTimeout(() => {
      runPredictiveSearch(query);
    }, 180);
  });

  miniCart.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-hiranya-cart-remove]');

    if (!removeButton) {
      return;
    }

    event.preventDefault();
    updateCartLine(Number(removeButton.dataset.line), 0);
  });
}

function initHiranyaProductForms() {
  document.querySelectorAll('[data-hiranya-product-root]').forEach((root) => {
    const form = root.querySelector('[data-hiranya-product-form]');
    const variantInput = root.querySelector('[data-hiranya-variant-id]');
    const priceNodes = Array.from(root.querySelectorAll('[data-hiranya-price]'));
    const compareNodes = Array.from(root.querySelectorAll('[data-hiranya-compare-price]'));
    const savingsNodes = Array.from(root.querySelectorAll('[data-hiranya-savings]'));
    const skuNodes = Array.from(root.querySelectorAll('[data-hiranya-sku]'));
    const skuRow = root.querySelector('[data-hiranya-sku-row]');
    const addToCartLabel = root.querySelector('[data-hiranya-submit-label]');
    const addToCartButton = root.querySelector('[data-hiranya-submit]');
    const buyNowButton = root.querySelector('[data-hiranya-buy-now]');
    const mobileBar = root.querySelector('[data-hiranya-mobile-cartbar]');
    const mobileBarButton = root.querySelector('[data-hiranya-mobile-submit]');
    const lineSkuInput = root.querySelector('[data-hiranya-line-sku]');
    const variantsScript = root.querySelector('[data-hiranya-variants]');

    if (!form || !variantInput || !variantsScript) {
      return;
    }

    initHiranyaProductMedia(root);
    initHiranyaSizeGuide(root);
    initHiranyaRecentlyViewed(root);
    initHiranyaPairWith(root);

    const variants = JSON.parse(variantsScript.textContent);
    const optionWrappers = Array.from(root.querySelectorAll('[data-hiranya-option-group]'));
    const sizeDrawer = root.querySelector('[data-hiranya-size-drawer]');
    const drawerOptionButtons = Array.from(root.querySelectorAll('[data-hiranya-drawer-option-button]'));
    const drawerSubmitButton = root.querySelector('[data-hiranya-size-drawer-submit]');
    const sizeDrawerCloseButtons = Array.from(root.querySelectorAll('[data-hiranya-size-drawer-close]'));
    const drawerPriceNode = root.querySelector('[data-hiranya-size-drawer-price]');
    const defaultDrawerPrice = drawerPriceNode?.textContent || '';
    const isMobilePdp = () => window.matchMedia('(max-width: 1023px)').matches;
    const requiresExplicitMobileSelection = optionWrappers.length > 0 && variants.length > 1;
    const state = optionWrappers.map((wrapper) => {
      const activeButton =
        wrapper.querySelector('[data-option-button].is-active') ||
        wrapper.querySelector('[data-option-button]');
      return activeButton ? activeButton.dataset.optionValue : '';
    });
    let selectedVariant = null;

    if (requiresExplicitMobileSelection && isMobilePdp()) {
      state.fill('');
    }

    const syncOptionButtons = () => {
      optionWrappers.forEach((group, index) => {
        const selectedValue = state[index] || '';
        group.querySelectorAll('[data-option-button]').forEach((button) => {
          const isActive = Boolean(selectedValue) && button.dataset.optionValue === selectedValue;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
    };

    const setActiveButton = (position, value) => {
      state[position - 1] = value;
      syncOptionButtons();
    };

    const isDrawerOptionAvailable = (position, value) => {
      return variants.some((variant) => {
        if (!variant.available) {
          return false;
        }

        return variant.options.every((optionValue, index) => {
          if (index === position - 1) {
            return optionValue === value;
          }

          return !state[index] || state[index] === optionValue;
        });
      });
    };

    const updateDrawerPrice = (variant) => {
      if (!drawerPriceNode) {
        return;
      }

      drawerPriceNode.textContent = variant?.price || defaultDrawerPrice;
    };

    const syncDrawerButtons = () => {
      drawerOptionButtons.forEach((button) => {
        const position = Number(button.dataset.optionPosition);
        const value = button.dataset.optionValue;
        const selectedValue = state[position - 1] || '';
        const isActive = Boolean(selectedValue) && value === selectedValue;
        const isAvailable = isDrawerOptionAvailable(position, value);

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.toggleAttribute('disabled', !isAvailable);
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    };

    const syncDrawerSubmit = (variant) => {
      if (!drawerSubmitButton) {
        return;
      }

      const canSubmit = Boolean(variant?.available);
      drawerSubmitButton.disabled = !canSubmit;
      drawerSubmitButton.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      drawerSubmitButton.textContent = 'Add to Cart';
    };

    const setSubmittingState = (isSubmitting, actionLabel) => {
      addToCartButton?.toggleAttribute('disabled', isSubmitting);
      buyNowButton?.toggleAttribute('disabled', isSubmitting);
      mobileBarButton?.toggleAttribute('disabled', isSubmitting);
      if (drawerSubmitButton && isSubmitting) {
        drawerSubmitButton.disabled = true;
        drawerSubmitButton.setAttribute('aria-disabled', 'true');
        drawerSubmitButton.textContent = actionLabel;
      }

      if (addToCartLabel && isSubmitting) {
        addToCartLabel.textContent = actionLabel;
      }
      if (mobileBarButton && isSubmitting) {
        mobileBarButton.textContent = actionLabel;
      }
    };

    const openSizeDrawer = () => {
      if (!sizeDrawer) {
        return false;
      }

      sizeDrawer.hidden = false;
      sizeDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hiranya-size-drawer-open');
      window.requestAnimationFrame(() => {
        sizeDrawer.classList.add('is-open');
      });
      return true;
    };

    const closeSizeDrawer = () => {
      if (!sizeDrawer) {
        return;
      }

      sizeDrawer.classList.remove('is-open');
      sizeDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hiranya-size-drawer-open');
      window.setTimeout(() => {
        if (sizeDrawer.getAttribute('aria-hidden') === 'true') {
          sizeDrawer.hidden = true;
        }
      }, 220);
    };

    const updateVariant = () => {
      const hasIncompleteSelection = state.some((value) => !value);

      if (hasIncompleteSelection) {
        selectedVariant = null;
        syncOptionButtons();
        syncDrawerButtons();
        syncDrawerSubmit(null);
        updateDrawerPrice(null);
        form.classList.remove('is-unavailable');
        root.classList.remove('is-unavailable', 'is-variant-selected');
        root.classList.add('is-size-unselected');
        variantInput.value = '';
        if (lineSkuInput) {
          lineSkuInput.value = '';
        }
        if (skuRow) {
          skuRow.hidden = true;
        }
        skuNodes.forEach((node) => {
          node.textContent = '';
        });
        addToCartButton?.toggleAttribute('disabled', false);
        buyNowButton?.toggleAttribute('disabled', false);
        mobileBarButton?.toggleAttribute('disabled', false);
        if (addToCartLabel && isMobilePdp()) {
          addToCartLabel.textContent = 'Add to Cart';
        }
        if (mobileBarButton && isMobilePdp()) {
          mobileBarButton.textContent = 'Add to Cart';
        }
        return null;
      }

      const variant = variants.find((candidate) => {
        return candidate.options.every((value, index) => value === state[index]);
      });

      if (!variant) {
        selectedVariant = null;
        syncDrawerButtons();
        syncDrawerSubmit(null);
        updateDrawerPrice(null);
        form.classList.add('is-unavailable');
        root.classList.add('is-unavailable');
        root.classList.remove('is-variant-selected', 'is-size-unselected');
        if (skuRow) {
          skuRow.hidden = true;
        }
        skuNodes.forEach((node) => {
          node.textContent = '';
        });
        if (lineSkuInput) {
          lineSkuInput.value = '';
        }
        addToCartButton?.toggleAttribute('disabled', true);
        buyNowButton?.toggleAttribute('disabled', true);
        mobileBarButton?.toggleAttribute('disabled', true);
        if (addToCartLabel) {
          addToCartLabel.textContent = 'Unavailable';
        }
        if (mobileBarButton) {
          mobileBarButton.textContent = 'Unavailable';
        }
        return null;
      }

      selectedVariant = variant;
      syncOptionButtons();
      syncDrawerButtons();
      syncDrawerSubmit(variant);
      updateDrawerPrice(variant);
      form.classList.remove('is-unavailable');
      root.classList.remove('is-unavailable');
      root.classList.remove('is-size-unselected');
      root.classList.add('is-variant-selected');
      variantInput.value = variant.id;
      if (lineSkuInput) {
        lineSkuInput.value = variant.sku || '';
      }
      addToCartButton?.toggleAttribute('disabled', !variant.available);
      buyNowButton?.toggleAttribute('disabled', !variant.available);
      mobileBarButton?.toggleAttribute('disabled', !variant.available);

      priceNodes.forEach((node) => {
        node.textContent = variant.price;
      });

      compareNodes.forEach((node) => {
        node.textContent = variant.compare_at_price || '';
        node.classList.toggle('hidden', !variant.compare_at_price);
      });

      savingsNodes.forEach((node) => {
        node.textContent = variant.savings || '';
        node.classList.toggle('hidden', !variant.savings);
      });

      const hasSku = Boolean(String(variant.sku || '').trim());
      if (skuRow) {
        skuRow.hidden = !hasSku;
      }
      skuNodes.forEach((node) => {
        node.textContent = variant.sku || '';
      });

      const buttonText = variant.available ? 'Add to Cart' : 'Sold Out';
      if (addToCartLabel) {
        addToCartLabel.textContent = buttonText;
      }
      if (mobileBarButton) {
        mobileBarButton.textContent = buttonText + ' - ' + variant.price;
      }
      return variant;
    };

    const submitAddToCart = async (formData, action) => {
      const pendingText = action === 'checkout' ? 'Processing…' : 'Adding…';
      setSubmittingState(true, pendingText);

      try {
        const response = await fetch(`${window.theme?.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        if (!response.ok) {
          throw new Error('Unable to add this product right now.');
        }

        if (action === 'checkout') {
          window.location.href = '/checkout';
          return;
        }

        if (window.HiranyaUI?.openCart) {
          await window.HiranyaUI.openCart();
        }
      } catch (error) {
        window.alert(error.message || 'Unable to add this product right now.');
      } finally {
        setSubmittingState(false, 'Add to Cart');
        updateVariant();
      }
    };

    root.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const position = Number(button.dataset.optionPosition);
        setActiveButton(position, button.dataset.optionValue);
        updateVariant();
      });
    });

    drawerOptionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) {
          return;
        }

        const position = Number(button.dataset.optionPosition);
        setActiveButton(position, button.dataset.optionValue);
        updateVariant();
      });
    });

    drawerSubmitButton?.addEventListener('click', () => {
      if (!selectedVariant || !selectedVariant.available) {
        openSizeDrawer();
        return;
      }

      closeSizeDrawer();
      if (addToCartButton) {
        form.requestSubmit(addToCartButton);
      }
    });

    sizeDrawerCloseButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeSizeDrawer();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (!sizeDrawer || sizeDrawer.hidden || event.key !== 'Escape') {
        return;
      }

      closeSizeDrawer();
    });

    if (mobileBar && mobileBarButton) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const shouldShow = !entry.isIntersecting;
            mobileBar.classList.toggle('is-visible', shouldShow);
            mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          });
        },
        { rootMargin: '-120px 0px 0px 0px' }
      );

      const buttonBlock = root.querySelector('[data-hiranya-buttons]');
      if (buttonBlock) {
        observer.observe(buttonBlock);
      }

      mobileBarButton.addEventListener('click', () => {
        if (requiresExplicitMobileSelection && isMobilePdp() && !selectedVariant) {
          openSizeDrawer();
          return;
        }

        if (addToCartButton) {
          form.requestSubmit(addToCartButton);
        }
      });
    }

    form.addEventListener('submit', async (event) => {
      const action = event.submitter?.dataset.hiranyaAction || 'add';

      if (requiresExplicitMobileSelection && isMobilePdp() && !selectedVariant) {
        event.preventDefault();
        openSizeDrawer();
        return;
      }

      if (root.classList.contains('is-unavailable')) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      await submitAddToCart(new FormData(form), action);
    });

    updateVariant();
  });
}

function initHiranyaPairWith(root) {
  const pairRoot = root.querySelector('[data-hiranya-pair-root]');
  const pairGrid = root.querySelector('[data-hiranya-pair-grid]');

  if (!pairRoot || !pairGrid) {
    return;
  }

  const bindPairForm = (pairForm) => {
    if (!pairForm || pairForm.dataset.hiranyaBound === 'true') {
      return;
    }

    pairForm.dataset.hiranyaBound = 'true';

    const select = pairForm.querySelector('[data-hiranya-pair-select]');
    const priceNode = pairForm.closest('.hiranya-pdp__pair-copy')?.querySelector('[data-hiranya-pair-price]');
    const submitButton = pairForm.querySelector('button[type="submit"]');
    const syncSelectedVariant = () => {
      const selectedOption = select?.options?.[select.selectedIndex];
      const isAvailable = selectedOption ? selectedOption.dataset.available !== 'false' : true;

      if (priceNode && selectedOption?.dataset.price) {
        priceNode.textContent = selectedOption.dataset.price;
      }

      if (submitButton) {
        submitButton.disabled = !isAvailable;
        submitButton.textContent = isAvailable ? 'Add' : 'Sold Out';
      }
    };

    select?.addEventListener('change', syncSelectedVariant);
    syncSelectedVariant();

    pairForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (submitButton?.disabled) {
        return;
      }

      const originalLabel = submitButton?.textContent || 'Add';

      try {
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Adding…';
        }

        const response = await fetch(`${window.theme?.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(pairForm),
        });

        if (!response.ok) {
          throw new Error('Unable to add this item right now.');
        }

        if (window.HiranyaUI?.openCart) {
          await window.HiranyaUI.openCart();
        }
      } catch (error) {
        window.alert(error.message || 'Unable to add this item right now.');
      } finally {
        if (submitButton) {
          submitButton.textContent = originalLabel;
        }
        syncSelectedVariant();
      }
    });
  };

  Array.from(pairGrid.querySelectorAll('[data-hiranya-pair-form]')).forEach(bindPairForm);

  const pairSkusScript = root.querySelector('[data-hiranya-pair-skus]');
  if (!pairSkusScript) {
    if (!pairGrid.children.length) {
      pairRoot.hidden = true;
    }
    return;
  }

  let pairSkuValues = null;
  try {
    pairSkuValues = JSON.parse(pairSkusScript.textContent || 'null');
  } catch (error) {
    pairSkuValues = pairSkusScript.textContent || '';
  }

  const normalizedSkus = (Array.isArray(pairSkuValues) ? pairSkuValues : [pairSkuValues])
    .flatMap((value) => String(value || '').split(/[\n,]+/))
    .map((value) => hiranyaNormalizeSkuKey(value))
    .filter(Boolean);
  const uniqueSkus = Array.from(new Set(normalizedSkus));

  if (!uniqueSkus.length) {
    if (!pairGrid.children.length) {
      pairRoot.hidden = true;
    }
    return;
  }

  hiranyaLoadSkuMap(root.dataset.hiranyaSkuMapUrl)
    .then((skuMap) => {
      const matchedPairs = uniqueSkus
        .map((sku) => skuMap?.[sku])
        .filter((item) => item && Array.isArray(item.variants) && item.variants.length);

      if (!matchedPairs.length) {
        pairGrid.innerHTML = '';
        pairRoot.hidden = true;
        return;
      }

      pairGrid.innerHTML = matchedPairs.map((item) => hiranyaBuildPairCardMarkup(item)).join('');
      Array.from(pairGrid.querySelectorAll('[data-hiranya-pair-form]')).forEach(bindPairForm);
      pairRoot.hidden = false;
    })
    .catch(() => {
      if (!pairGrid.children.length) {
        pairRoot.hidden = true;
      }
    });
}

function initHiranyaProductMedia(root) {
  const triggers = Array.from(root.querySelectorAll('[data-hiranya-media-trigger]'));
  const lightbox = root.querySelector('[data-hiranya-lightbox]');

  if (!triggers.length || !lightbox) {
    return;
  }

  const image = lightbox.querySelector('[data-hiranya-lightbox-image]');
  const stage = lightbox.querySelector('[data-hiranya-lightbox-stage]');
  const count = lightbox.querySelector('[data-hiranya-lightbox-count]');
  const prevButton = lightbox.querySelector('[data-hiranya-lightbox-prev]');
  const nextButton = lightbox.querySelector('[data-hiranya-lightbox-next]');
  const closeButtons = Array.from(lightbox.querySelectorAll('[data-hiranya-lightbox-close]'));
  const items = triggers.map((trigger, index) => ({
    index,
    src: trigger.dataset.fullSrc || '',
    alt: trigger.dataset.alt || '',
  }));

  let currentIndex = 0;
  let isZoomed = false;
  let isPanning = false;
  let didPan = false;
  let suppressClick = false;
  let panX = 0;
  let panY = 0;
  let panStartX = 0;
  let panStartY = 0;
  let pointerStartX = 0;
  let pointerStartY = 0;

  const applyPan = () => {
    stage.style.setProperty('--zoom-pan-x', `${panX}px`);
    stage.style.setProperty('--zoom-pan-y', `${panY}px`);
  };

  const clampPan = (x, y) => {
    const maxX = Math.max(0, stage.clientWidth * 0.55);
    const maxY = Math.max(0, stage.clientHeight * 0.55);

    return {
      x: Math.max(-maxX, Math.min(maxX, x)),
      y: Math.max(-maxY, Math.min(maxY, y)),
    };
  };

  const resetZoom = () => {
    isZoomed = false;
    isPanning = false;
    didPan = false;
    suppressClick = false;
    panX = 0;
    panY = 0;
    stage.classList.remove('is-zoomed');
    stage.classList.remove('is-panning');
    stage.style.setProperty('--zoom-origin-x', '50%');
    stage.style.setProperty('--zoom-origin-y', '50%');
    applyPan();
  };

  const updateImage = () => {
    const item = items[currentIndex];

    if (!item) {
      return;
    }

    image.src = item.src;
    image.alt = item.alt;
    count.textContent = `${currentIndex + 1} / ${items.length}`;
    prevButton.disabled = items.length < 2;
    nextButton.disabled = items.length < 2;
    resetZoom();
  };

  const open = (index) => {
    currentIndex = index;
    updateImage();
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hiranya-lightbox-open');
    window.requestAnimationFrame(() => {
      lightbox.classList.add('is-open');
    });
  };

  const close = () => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hiranya-lightbox-open');
    resetZoom();

    window.setTimeout(() => {
      if (lightbox.getAttribute('aria-hidden') === 'true') {
        lightbox.hidden = true;
      }
    }, 220);
  };

  const move = (direction) => {
    currentIndex = (currentIndex + direction + items.length) % items.length;
    updateImage();
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      open(Number(trigger.dataset.index || 0));
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', close);
  });

  prevButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    move(-1);
  });

  nextButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    move(1);
  });

  stage?.addEventListener('click', () => {
    if (suppressClick) {
      suppressClick = false;
      return;
    }

    isZoomed = !isZoomed;
    stage.classList.toggle('is-zoomed', isZoomed);
    if (!isZoomed) {
      panX = 0;
      panY = 0;
      applyPan();
    }
  });

  stage?.addEventListener('mousemove', (event) => {
    if (!isZoomed || isPanning) {
      return;
    }

    const rect = stage.getBoundingClientRect();
    const originX = ((event.clientX - rect.left) / rect.width) * 100;
    const originY = ((event.clientY - rect.top) / rect.height) * 100;
    stage.style.setProperty('--zoom-origin-x', `${originX}%`);
    stage.style.setProperty('--zoom-origin-y', `${originY}%`);
  });

  stage?.addEventListener('pointerdown', (event) => {
    if (!isZoomed || event.button > 0) {
      return;
    }

    isPanning = true;
    didPan = false;
    pointerStartX = event.clientX;
    pointerStartY = event.clientY;
    panStartX = panX;
    panStartY = panY;
    stage.classList.add('is-panning');
    stage.setPointerCapture?.(event.pointerId);
    event.preventDefault();
  });

  stage?.addEventListener('pointermove', (event) => {
    if (!isPanning) {
      return;
    }

    const deltaX = event.clientX - pointerStartX;
    const deltaY = event.clientY - pointerStartY;

    if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
      didPan = true;
    }

    const clamped = clampPan(panStartX + deltaX, panStartY + deltaY);
    panX = clamped.x;
    panY = clamped.y;
    applyPan();
    event.preventDefault();
  });

  const stopPanning = (event) => {
    if (!isPanning) {
      return;
    }

    isPanning = false;
    stage.classList.remove('is-panning');
    try {
      stage.releasePointerCapture?.(event.pointerId);
    } catch (error) {
      // Ignore stale pointer captures after touch gestures are interrupted.
    }

    if (didPan) {
      suppressClick = true;
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    }
  };

  stage?.addEventListener('pointerup', stopPanning);
  stage?.addEventListener('pointercancel', stopPanning);
  stage?.addEventListener('pointerleave', stopPanning);

  document.addEventListener('keydown', (event) => {
    if (lightbox.hidden) {
      return;
    }

    if (event.key === 'Escape') {
      close();
    }
    if (event.key === 'ArrowLeft') {
      move(-1);
    }
    if (event.key === 'ArrowRight') {
      move(1);
    }
  });
}

function initHiranyaSizeGuide(root) {
  const triggers = Array.from(root.querySelectorAll('[data-hiranya-size-guide-trigger], .hiranya-pdp__size-guide'));
  const customTemplate = root.querySelector('[data-hiranya-size-chart-template]');
  const customModal = root.querySelector('[data-hiranya-size-chart-modal]');
  const customContent = root.querySelector('[data-hiranya-size-chart-content]');

  if (!triggers.length) {
    return;
  }

  const hasCustomChart =
    Boolean(customTemplate) &&
    Boolean(customModal) &&
    Boolean(customContent) &&
    Boolean(customTemplate.innerHTML.trim());

  const toCentimeters = (value) => {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
      return value;
    }

    const convertedValue = Math.round(numericValue * 2.54 * 10) / 10;
    return Number.isInteger(convertedValue) ? String(convertedValue) : convertedValue.toFixed(1);
  };

  const renderBodyMeasurementTable = (columns, rows, unit, conversionStartIndex) => {
    const headerCells = columns
      .map((column, index) => {
        const alignment = index === 0 ? ' style="text-align: center; width: auto;"' : '';
        return `<th scope="col"${alignment}>${column}</th>`;
      })
      .join('');
    const bodyRows = rows
      .map((row) => {
        const cells = row
          .map((cell, index) => {
            const value = unit === 'cm' && index >= conversionStartIndex ? toCentimeters(cell) : cell;
            return `<td>${value}</td>`;
          })
          .join('');
        return `<tr>${cells}</tr>`;
      })
      .join('');

    return `
      <table class="hiranya-size-chart__table" data-size-chart-table data-unit="${unit}" style="min-width: ${columns.length > 7 ? '760px' : '640px'}; table-layout: auto;"${unit === 'cm' ? ' hidden' : ''}>
        <thead>
          <tr>${headerCells}</tr>
        </thead>
        <tbody>${bodyRows}</tbody>
      </table>
    `;
  };

  const renderBodyMeasurementSection = (title, columns, rows, conversionStartIndex) => `
    <section class="hiranya-size-chart__section">
      <h4 class="hiranya-size-chart__section-title">${title}</h4>
      <div class="hiranya-size-chart__table-wrap">
        ${renderBodyMeasurementTable(columns, rows, 'in', conversionStartIndex)}
        ${renderBodyMeasurementTable(columns, rows, 'cm', conversionStartIndex)}
      </div>
    </section>
  `;

  const buildBodyMeasurementsMarkup = () => {
    const topColumns = ['US', 'UK', 'EU', 'Hiranya', 'Chest', 'Waist', 'Hip', 'Shoulder'];
    const topRows = [
      ['1', '4', '32', 'XXS', 30, 25, 34, 14],
      ['2', '6', '34', 'XS', 32, 27, 35, 14.5],
      ['4', '8', '36', 'S', 34, 29, 37, 15],
      ['6', '10', '38', 'M', 36, 31, 39, 15.5],
      ['8', '12', '40', 'L', 38, 33, 41.5, 16],
      ['10', '14', '42', 'XL', 40, 35, 44.5, 16.5],
      ['12', '16', '44', 'XXL', 42, 37, 47.5, 17],
    ];
    const bottomColumns = ['US', 'UK', 'EU', 'Hiranya', 'Waist', 'Thigh', 'Hip'];
    const bottomRows = [
      ['1', '4', '32', 'XXS', 25, 20, 34],
      ['2', '6', '34', 'XS', 27, 21, 35],
      ['4', '8', '36', 'S', 29, 22.5, 37],
      ['6', '10', '38', 'M', 31, 24, 39],
      ['8', '12', '40', 'L', 33, 26, 41.5],
      ['10', '14', '42', 'XL', 35, 28.5, 44.5],
      ['12', '16', '44', 'XXL', 37, 31, 47.5],
    ];

    return `
      <div class="hiranya-size-chart__sections" data-size-chart-measurement-panel="body" hidden>
        ${renderBodyMeasurementSection('Top - Body Measurements', topColumns, topRows, 4)}
        ${renderBodyMeasurementSection('Bottom - Body Measurements', bottomColumns, bottomRows, 4)}
        <p class="hiranya-size-chart__note" data-size-chart-unit-note data-unit="in">Our comfort fit garments have 8-10 inches ease from the body measurements.</p>
        <p class="hiranya-size-chart__note" data-size-chart-unit-note data-unit="cm" hidden>Our comfort fit garments have 20-25 cm ease from the body measurements.</p>
      </div>
    `;
  };

  const syncChartUnit = (chart, unit) => {
    if (!chart) {
      return;
    }

    chart.dataset.unit = unit;

    chart.querySelectorAll('[data-size-chart-unit-button]').forEach((button) => {
      const isActive = button.dataset.unit === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    chart.querySelectorAll('[data-size-chart-table]').forEach((table) => {
      table.hidden = table.dataset.unit !== unit;
    });

    chart.querySelectorAll('[data-size-chart-unit-note]').forEach((note) => {
      note.hidden = note.dataset.unit !== unit;
    });
  };

  const syncMeasurementMode = (chart, mode) => {
    if (!chart) {
      return;
    }

    const activeMode = mode === 'body' ? 'body' : 'garment';
    chart.dataset.measurement = activeMode;

    chart.querySelectorAll('[data-size-chart-measurement-button]').forEach((button) => {
      const isActive = button.dataset.measurement === activeMode;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    chart.querySelectorAll('[data-size-chart-measurement-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sizeChartMeasurementPanel !== activeMode;
    });

    const note = chart.querySelector('.hiranya-size-chart__toolbar .hiranya-size-chart__note');
    if (note) {
      note.textContent =
        activeMode === 'body'
          ? note.dataset.bodyCopy || 'Body measurements are reference body measurements. Toggle between inches and centimeters.'
          : note.dataset.garmentCopy || 'All measurements are garment measurements. Toggle between inches and centimeters.';
    }

    syncChartUnit(chart, chart.dataset.unit || 'in');
  };

  const enhanceMeasurementToggle = (chart) => {
    if (!chart || chart.dataset.measurementEnhanced === 'true') {
      return;
    }

    const garmentSections = chart.querySelector('.hiranya-size-chart__sections');
    const toolbar = chart.querySelector('.hiranya-size-chart__toolbar');

    if (!garmentSections || !toolbar) {
      return;
    }

    chart.dataset.measurementEnhanced = 'true';
    garmentSections.dataset.sizeChartMeasurementPanel = 'garment';

    const note = toolbar.querySelector('.hiranya-size-chart__note');
    if (note) {
      note.dataset.garmentCopy = note.textContent.trim() || 'All measurements are garment measurements. Toggle between inches and centimeters.';
      note.dataset.bodyCopy = 'Body measurements are reference body measurements. Toggle between inches and centimeters.';
    }

    const measurementToolbar = document.createElement('div');
    measurementToolbar.className = 'hiranya-size-chart__toolbar';
    measurementToolbar.setAttribute('data-size-chart-measurement-toolbar', '');
    measurementToolbar.innerHTML = `
      <div class="hiranya-size-chart__copy">
        <p class="hiranya-size-chart__section-title">Measurement Type</p>
      </div>
      <div class="hiranya-size-chart__toggle" role="group" aria-label="Toggle measurement type">
        <button type="button" class="hiranya-size-chart__toggle-button is-active" data-size-chart-measurement-button data-measurement="garment" aria-pressed="true">Garment Measurements</button>
        <button type="button" class="hiranya-size-chart__toggle-button" data-size-chart-measurement-button data-measurement="body" aria-pressed="false">Body Measurements</button>
      </div>
    `;

    toolbar.before(measurementToolbar);

    const bodyContainer = document.createElement('div');
    bodyContainer.innerHTML = buildBodyMeasurementsMarkup();
    garmentSections.after(bodyContainer.firstElementChild);
    syncMeasurementMode(chart, 'garment');
  };

  const initialiseCustomCharts = () => {
    if (!hasCustomChart) {
      return;
    }

    customContent.innerHTML = customTemplate.innerHTML;
    customContent.querySelectorAll('[data-size-chart]').forEach((chart) => {
      enhanceMeasurementToggle(chart);
      syncChartUnit(chart, chart.dataset.unit || 'in');
      syncMeasurementMode(chart, chart.dataset.measurement || 'garment');
    });
  };

  const closeCustomSizeGuide = () => {
    if (!hasCustomChart) {
      return;
    }

    customModal.classList.remove('is-open');
    customModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hiranya-size-chart-open');

    window.setTimeout(() => {
      if (customModal.getAttribute('aria-hidden') === 'true') {
        customModal.hidden = true;
      }
    }, 220);
  };

  const openCustomSizeGuide = () => {
    if (!hasCustomChart) {
      return false;
    }

    initialiseCustomCharts();
    customModal.hidden = false;
    customModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hiranya-size-chart-open');
    window.requestAnimationFrame(() => {
      customModal.classList.add('is-open');
    });
    return true;
  };

  const openExistingSizeGuide = () => {
    const button = document.querySelector('.scr-open-size-chart');

    if (button) {
      button.click();
      return true;
    }

    if (window.sizeChartsRelentless?.modal?.css) {
      window.sizeChartsRelentless.modal.css({
        opacity: 1,
        visibility: 'visible',
        transform: 'translate(-50%, 0%) scale(1)',
      });

      const shadow = document.querySelector('.scr-shadow');
      if (shadow) {
        shadow.style.opacity = '1';
        shadow.style.visibility = 'visible';
      }

      return true;
    }

    return false;
  };

  if (hasCustomChart) {
    customModal.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest('[data-hiranya-size-chart-close]');

      if (closeTrigger) {
        event.preventDefault();
        closeCustomSizeGuide();
        return;
      }

      const unitButton = event.target.closest('[data-size-chart-unit-button]');
      if (unitButton) {
        event.preventDefault();
        syncChartUnit(unitButton.closest('[data-size-chart]'), unitButton.dataset.unit || 'in');
        return;
      }

      const measurementButton = event.target.closest('[data-size-chart-measurement-button]');
      if (measurementButton) {
        event.preventDefault();
        syncMeasurementMode(measurementButton.closest('[data-size-chart]'), measurementButton.dataset.measurement || 'garment');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (customModal.hidden) {
        return;
      }

      if (event.key === 'Escape') {
        closeCustomSizeGuide();
      }
    });
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (openCustomSizeGuide()) {
        return;
      }

      if (openExistingSizeGuide()) {
        return;
      }

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;

        if (openExistingSizeGuide() || attempts > 20) {
          window.clearInterval(timer);
        }
      }, 150);
    });
  });
}

function initHiranyaRecentlyViewed(root) {
  const currentHandle = root.dataset.hiranyaProductHandle;
  const currentFabric = String(root.dataset.hiranyaProductFabric || '').trim();
  const fabricMapScript = root.querySelector('[data-hiranya-product-fabrics]');
  const section = root.querySelector('[data-hiranya-recently-viewed-section]');
  const grid = root.querySelector('[data-hiranya-recently-viewed-grid]');

  if (!currentHandle || !section || !grid) {
    return;
  }

  const storageKey = 'hiranyaRecentlyViewed';
  const fabricStorageKey = 'hiranyaProductFabricMap';
  let viewedHandles = [];
  let fabricMap = {};

  try {
    viewedHandles = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
  } catch (error) {
    viewedHandles = [];
  }

  try {
    fabricMap = JSON.parse(window.localStorage.getItem(fabricStorageKey) || '{}') || {};
  } catch (error) {
    fabricMap = {};
  }

  try {
    fabricMap = Object.assign({}, fabricMap, JSON.parse(fabricMapScript?.textContent || '{}'));
  } catch (error) {
    // Keep stored fabric data if the inline map cannot be parsed.
  }

  if (currentHandle && currentFabric) {
    fabricMap[currentHandle] = currentFabric;
  }

  viewedHandles = [currentHandle, ...viewedHandles.filter((handle) => handle && handle !== currentHandle)].slice(0, 12);

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(viewedHandles));
    window.localStorage.setItem(fabricStorageKey, JSON.stringify(fabricMap));
  } catch (error) {
    // Ignore storage failures.
  }

  const actualRecentHandles = viewedHandles.filter((handle) => handle !== currentHandle);
  if (!actualRecentHandles.length) {
    return;
  }

  const handles = actualRecentHandles.slice(0, 12);
  const fallbackHandles = (section.dataset.hiranyaFallbackHandles || '')
    .split(',')
    .map((handle) => handle.trim())
    .filter(Boolean);

  fallbackHandles.forEach((handle) => {
    if (handles.length < 12 && handle !== currentHandle && !handles.includes(handle)) {
      handles.push(handle);
    }
  });

  Promise.all(
    handles.map(async (handle) => {
      const response = await fetch(`/products/${handle}.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`Unable to load ${handle}`);
      }

      return response.json();
    })
  )
    .then((products) => {
      if (!products.length) {
        return;
      }

      grid.innerHTML = products
        .filter(Boolean)
        .slice(0, 12)
        .map((product) => hiranyaBuildProductCardMarkup(product, fabricMap))
        .join('');

      if (grid.innerHTML.trim()) {
        section.classList.remove('is-hidden');
      }
    })
    .catch(() => {
      section.classList.add('is-hidden');
    });
}

function initHiranyaWelcomePopup() {
  return;

  const popup = document.querySelector('[data-hiranya-welcome-popup]');

  if (!popup || window.Shopify?.designMode) {
    return;
  }

  const storageKey = 'hiranyaWelcomePopupSeen';
  const cookieName = 'hiranya_welcome_popup_seen';
  const closeButtons = Array.from(popup.querySelectorAll('[data-hiranya-welcome-popup-close]'));
  const copyButton = popup.querySelector('[data-hiranya-welcome-copy]');
  const couponNode = popup.querySelector('[data-hiranya-welcome-coupon]');
  const form = popup.querySelector('.hiranya-welcome-popup__form');
  const emailInput = popup.querySelector('input[type="email"]');
  let showTimer = null;

  const hasSeenPopup = () => {
    try {
      if (window.localStorage.getItem(storageKey) === 'true') {
        return true;
      }
    } catch (error) {
      // Ignore storage failures and fall back to the cookie check.
    }

    return document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${cookieName}=true`));
  };

  const markSeen = () => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Ignore storage failures.
    }

    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `${cookieName}=true; path=/; max-age=${maxAge}; SameSite=Lax`;
  };

  const closePopup = (shouldMarkSeen = true) => {
    if (showTimer) {
      window.clearTimeout(showTimer);
      showTimer = null;
    }

    if (shouldMarkSeen) {
      markSeen();
    }

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hiranya-welcome-popup-open');
  };

  const openPopup = () => {
    if (hasSeenPopup()) {
      return;
    }

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hiranya-welcome-popup-open');
    window.setTimeout(() => emailInput?.focus({ preventScroll: true }), 260);
  };

  if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
    markSeen();
    return;
  }

  if (hasSeenPopup()) {
    return;
  }

  showTimer = window.setTimeout(openPopup, 1100);

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closePopup(true));
  });

  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      closePopup(true);
    }
  });

  copyButton?.addEventListener('click', async () => {
    const code = couponNode?.textContent?.trim() || 'DEBUT10';
    const originalLabel = copyButton.getAttribute('aria-label') || `Copy coupon code ${code}`;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const temporaryInput = document.createElement('input');
        temporaryInput.value = code;
        temporaryInput.setAttribute('readonly', '');
        temporaryInput.style.position = 'fixed';
        temporaryInput.style.left = '-9999px';
        document.body.appendChild(temporaryInput);
        temporaryInput.select();
        document.execCommand('copy');
        temporaryInput.remove();
      }

      copyButton.classList.add('is-copied');
      copyButton.setAttribute('aria-label', copyButton.dataset.copyLabel || 'Copied');
      window.setTimeout(() => {
        copyButton.classList.remove('is-copied');
        copyButton.setAttribute('aria-label', originalLabel);
      }, 1400);
    } catch (error) {
      copyButton.setAttribute('aria-label', originalLabel);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup(true);
    }
  });

  form?.addEventListener('submit', () => {
    markSeen();
  });
}
